import React from "react";
import styles from "./Navbar.module.css";

function Navbar(props) {
  return (
    <nav className={styles.navbar}>
      <div className={styles.hamburger} onClick={() => props.setShowMenu(true)}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 6H20V8H4V6ZM4 11H20V13H4V11ZM4 16H20V18H4V16Z"
            fill="#3C3E3F"
          />
        </svg>
      </div>
      <h1 className={styles.title}>{props.title}</h1>
      <div className={styles.icon}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 22C11.4696 22 10.9609 21.7893 10.5858 21.4142C10.2107 21.0391 10 20.5304 10 20H14C14 20.5304 13.7893 21.0391 13.4142 21.4142C13.0391 21.7893 12.5304 22 12 22ZM20 19H4V17L6 16V10.5C6 7.038 7.421 4.793 10 4.18V2H13C12.3479 2.86394 11.9967 3.91762 12 5C12 5.251 12.019 5.502 12.056 5.751H12C11.3995 5.71211 10.7989 5.82436 10.2529 6.07749C9.70704 6.33061 9.23328 6.71655 8.875 7.2C8.25255 8.18456 7.94714 9.33638 8 10.5V17H16V10.5C16 10.289 15.993 10.086 15.979 9.9C16.6405 10.0366 17.3226 10.039 17.985 9.907C17.996 10.118 18 10.319 18 10.507V16L20 17V19ZM17 8C16.2044 8 15.4413 7.68393 14.8787 7.12132C14.3161 6.55871 14 5.79565 14 5C14 4.20435 14.3161 3.44129 14.8787 2.87868C15.4413 2.31607 16.2044 2 17 2C17.7956 2 18.5587 2.31607 19.1213 2.87868C19.6839 3.44129 20 4.20435 20 5C20 5.79565 19.6839 6.55871 19.1213 7.12132C18.5587 7.68393 17.7956 8 17 8Z"
            fill="#3C3E3F"
          />
          <circle cx="18" cy="4.5" r="4.5" fill="#FC476E" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.875 8.85823C18.8159 8.35868 20.25 6.59682 20.25 4.5C20.25 2.40318 18.8159 0.641318 16.875 0.14177C17.2346 0.0492221 17.6115 0 18 0C20.4853 0 22.5 2.01472 22.5 4.5C22.5 6.98528 20.4853 9 18 9C17.6115 9 17.2346 8.95078 16.875 8.85823Z"
            fill="#CC2B5A"
          />
          <path
            d="M17.89 6.5H17.41V4.215H16.625V3.87C17.075 3.86 17.385 3.61 17.46 3.26H17.89V6.5Z"
            fill="white"
          />
        </svg>
      </div>
    </nav>
  );
}

export default Navbar;
